import React from 'react'
import { StyledIcon } from '../StyledIcon'
import { StyledIconPropsType } from './types'

const TruckOutlineIcon = ({
  icon = "truck-outline",
  color="plain",
  viewBox= "0 0 32 32",
  width = "32px",
  height = "32px",
  customProps,
} : StyledIconPropsType) => {
  return (
    <StyledIcon
      width={width}
      height={height}
      viewBox={viewBox}
      a11yTitle={icon}
      color={color}
      fill="none"
      {...customProps}
    >
      <path d="M21.332 4H1.33203V21.3333H21.332V4Z" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.332 10.668H26.6654L30.6654 14.668V21.3346H21.332V10.668Z" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.33333 28.0007C9.17428 28.0007 10.6667 26.5083 10.6667 24.6673C10.6667 22.8264 9.17428 21.334 7.33333 21.334C5.49238 21.334 4 22.8264 4 24.6673C4 26.5083 5.49238 28.0007 7.33333 28.0007Z" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M24.6654 28.0007C26.5063 28.0007 27.9987 26.5083 27.9987 24.6673C27.9987 22.8264 26.5063 21.334 24.6654 21.334C22.8244 21.334 21.332 22.8264 21.332 24.6673C21.332 26.5083 22.8244 28.0007 24.6654 28.0007Z" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </StyledIcon>
  )
}

export default TruckOutlineIcon